import React, { Component } from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import { theme } from '../../Theming/Theming';
import { scrollBar } from '../../ui/General';
import { imageOverlay } from '../../CategoryPage/ProductCard';

const Wrapper = styled('div')`
  display: flex;
  ${theme.below.md} {
    width: 100%;
    margin: 0.5rem auto 0;
    order: 2;
  }
  ${theme.above.lg} {
    padding: 2px;
    width: 18%;
    flex-direction: column;
    order: 1;
    position: absolute;
    top: 0;
    height: 100%;
    left: 0;
    ${scrollBar}
  }
`;

const ImageWrapper = styled('div')`
  width: 100%;
  cursor: pointer;
  border: 1px solid white;
  transitionopacity: 0.2s;
  opacity: 0.7;
  //box-shadow: 1px 1px 3px #555;
  &.selected {
    opacity: 0.95;
    border-color: ${theme.colors.greys[3]};
  }
  &:hover {
    opacity: 0.85;
  }
  &:focus {
    outline: none;
  }
  margin-right: 1rem;
  &:last-child {
    margin-right: 0;
  }
  ${theme.below.md} {
    width: 80px;
  }
  ${theme.above.lg} {
    &:not(:last-child) {
      margin-bottom: 0.6rem;
    }
  }
  ${imageOverlay}
`;

class Thumbs extends Component {
  changeImage = (curImageNum, newImageNum) => {
    if (curImageNum === newImageNum) return;
    this.props.selectSliderImage(newImageNum, true);
  };
  render() {
    const { activeSliderImage, images } = this.props;
    return (
      <Wrapper className="thumbs-wrapper">
        {images.map((image, index) => (
          <ImageWrapper
            key={index}
            className={activeSliderImage === index && 'selected'}
            onClick={e => this.changeImage(activeSliderImage, index)}
          >
            <Image src={image.url} sizes={[250]} aspect={'1:1'} crop={false} />
          </ImageWrapper>
        ))}
      </Wrapper>
    );
  }
}

export default Thumbs;
